import { subscribeToAuction, subscribeToAllAuctionsOnPage, resetBidPageAuctionSubscriptions } from "channels/auction_channel";

function initCountdownsAndAdminAuctionRealtime() {
  if (window._monetCountdownInitDone) return;
  window._monetCountdownInitDone = true;

  function monetAdminAuctionDebugEnabled() {
    try {
      if (window.MonetDebugActiveAuctions === true) return true;
      if (typeof localStorage !== "undefined" && localStorage.getItem("MonetDebugActiveAuctions") === "1") return true;
    } catch (e) {}
    return false;
  }

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  // Handle "ADD FROM REGISTER" button - save form first, then open modal
  var addFromRegisterBtn = document.getElementById('addFromRegisterBtn');
  if (addFromRegisterBtn) {
    addFromRegisterBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var form = document.getElementById('ad-form');
      if (!form) return;

      var modalTarget = this.getAttribute('data-bs-target');
      var formData = new FormData(form);
      // Add a flag to indicate this is a save-before-modal action
      formData.append('save_before_modal', 'true');

      // Disable button during save
      this.disabled = true;
      var originalText = this.innerHTML;
      this.innerHTML = '<span>Saving...</span>';

      fetch(form.action, {
        method: 'PUT',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      })
      .then(response => {
        if (response.ok) {
          // Open the modal after successful save
          var modalElement = document.querySelector(modalTarget);
          if (modalElement) {
            var modal = new bootstrap.Modal(modalElement);
            modal.show();
          }
        } else {
        }
      })
      .catch(error => {
      })
      .finally(() => {
        // Re-enable button
        this.disabled = false;
        this.innerHTML = originalText;
      });
    });
  }

  function auctionHasValidHighestBidText(highestBidText) {
    if (!highestBidText) return false;
    var t = String(highestBidText).trim();
    // Placeholders are hyphen-only strings (e.g. "--------")
    if (/^-+$/.test(t)) return false;
    // Real values include digits (and usually a currency sign)
    return /[0-9]/.test(t);
  }

  function updateAdminAuctionControlsForCountdown(auctionRemainingTimeEl, ended) {
    // Only the admin "manage active auctions" cards use these controls.
    if (!document.getElementById('active-auction')) return;

    var auctionCard = auctionRemainingTimeEl.closest('.items-type-1[data-auction-id]');
    if (!auctionCard) return;

    var cardAuctionId = auctionCard.getAttribute("data-auction-id");

    var auctionId = auctionCard.getAttribute('data-auction-id');

    // Prefer the explicit hooks we added, but also support older/variant markup:
    // 1) explicit hook attribute
    // 2) explicit class
    // 3) href contains accept_reject_highest_bid inside this card block
    // 4) global href lookup with this auction id (button can be outside .items-type-1)
    var acceptLink =
      auctionCard.querySelector('.accept-reject-highest-bid-link') ||
      auctionCard.querySelector('a[data-enable-on-end="true"]') ||
      auctionCard.querySelector('a[href*="accept_reject_highest_bid"]') ||
      (auctionId ? document.querySelector('a[href*="/admin/offers/' + auctionId + '/accept_reject_highest_bid"]') : null);
    var editLink =
      auctionCard.querySelector('.edit-auction-info-link') ||
      (auctionId ? document.querySelector('a[href*="/admin/auctions/"][href*="back_path="]') : null);

    if (ended) {
      if (acceptLink) {
        acceptLink.classList.remove('disableattchmentbutton');
        acceptLink.classList.remove('auction-ended-not-reached');
      }
      if (editLink) {
        // Editing ad info becomes blocked once the auction is ended.
        editLink.classList.add('disableattchmentbutton');
        editLink.classList.add('auction-ended');
      }
    } else {
      // Do not force-disable buttons while auction is running (server-side rules decide initial state).
      if (editLink) {
        // Remove only the end-time disable marker (do not override role-based disables).
        if (editLink.classList.contains('auction-ended')) {
          editLink.classList.remove('disableattchmentbutton');
          editLink.classList.remove('auction-ended');
        }
      }
    }
  }

  function updateOfferControlsForCountdown(auctionRemainingTimeEl, ended) {
    var auctionCard = auctionRemainingTimeEl.closest('.items-type-1[data-auction-id]');
    if (!auctionCard) return;

    var offerButtons = auctionCard.querySelectorAll('.wishlist_offer_button, .bid_offer_button, .auction_offer_button');
    var offerInputs = auctionCard.querySelectorAll('[id^="wishlist_offer_"], [id^="bid_offer_amount_"], #auction_offer');

    offerButtons.forEach(function(button) {
      if (ended) {
        button.classList.add('disableattchmentbutton');
        button.setAttribute('data-disabled-by-timesup', 'true');
        button.setAttribute('disabled', 'disabled');
      } else {
        if (button.getAttribute('data-disabled-by-timesup') === 'true') {
          button.classList.remove('disableattchmentbutton');
          button.removeAttribute('disabled');
          button.removeAttribute('data-disabled-by-timesup');
        }
      }
    });

    offerInputs.forEach(function(input) {
      if (ended) {
        input.classList.add('disableattchmentbutton');
        input.setAttribute('data-disabled-by-timesup', 'true');
        input.setAttribute('disabled', 'disabled');
      } else {
        if (input.getAttribute('data-disabled-by-timesup') === 'true') {
          input.classList.remove('disableattchmentbutton');
          input.removeAttribute('disabled');
          input.removeAttribute('data-disabled-by-timesup');
        }
      }
    });
  }

  function updateCountdown(auction) {
    const countdownElement = auction.querySelector('.countdown');
    if (!countdownElement) return;
    
    const endTimeAttr = auction.getAttribute('data-end-time');
    if (!endTimeAttr) return;
    
    const endTime = new Date(endTimeAttr);
    const now = new Date();
    const timeRemaining = endTime - now;

    if (timeRemaining <= 0) {
      // Find the times_up_label in the same container
      var timesUpLabel = 'Times up';
      var closestContainer = auction.closest('.d-inline-block, .text-center, .text-16');
      if (closestContainer) {
        var timesUpInput = $(closestContainer).find('input[id^="times_up_label"]');
        if (timesUpInput.length) {
          timesUpLabel = timesUpInput.val();
        } else {
          // Fallback to global times_up_label
          var globalLabel = $("#times_up_label").val();
          if (globalLabel) timesUpLabel = globalLabel;
        }
      } else {
        // Fallback to global times_up_label
        var globalLabel = $("#times_up_label").val();
        if (globalLabel) timesUpLabel = globalLabel;
      }
      countdownElement.innerHTML = timesUpLabel;
      updateAdminAuctionControlsForCountdown(auction, true);
      updateOfferControlsForCountdown(auction, true);
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Format hours, minutes, and seconds to always have two digits
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      var dayLabel = $("#days_translation").val();
      countdownElement.innerHTML = `${days} ${dayLabel} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      updateAdminAuctionControlsForCountdown(auction, false);
      updateOfferControlsForCountdown(auction, false);
    }
  }

  // Let auction_channel.js refresh a card immediately after a websocket updates data-end-time
  // (otherwise wishlist / active bids can sit on "time's up" for up to 1s or look stuck in the last minute).
  window.__monetRefreshAuctionCountdownWrap = function (timeWrap) {
    try {
      if (timeWrap) updateCountdown(timeWrap);
    } catch (e) {
      /* ignore */
    }
  };

  function applyListingPricesPayloadToBidCards(payload) {
    if (!payload || typeof payload !== "object") return;
    Object.keys(payload).forEach(function (id) {
      var entry = payload[id];
      if (!entry || entry.ended) return;

      if (entry.highest_ad_bid != null && entry.highest_ad_bid !== "") {
        var highestBidEl = document.getElementById("highest_bid_" + id);
        if (highestBidEl) {
          var currentText = highestBidEl.textContent || "";
          var currencySign = (currentText.match(/(EUR|€|\$|£|¥)/i) || [null, "EUR"])[1];
          highestBidEl.textContent = entry.highest_ad_bid + " " + currencySign;
        }
      }

      if (entry.ad_publication_date != null && entry.ad_publication_date !== "") {
        var closeDateEl = document.getElementById("auction_close_date_" + id);
        if (closeDateEl) closeDateEl.textContent = String(entry.ad_publication_date).replace(" - ", " ");
      }

      if (entry.ends_at != null) {
        var timeWrap = document.querySelector('.items-type-1[data-auction-id="' + id + '"] .auction_remaining_time');
        if (timeWrap) {
          var iso = new Date(parseInt(entry.ends_at, 10) * 1000).toISOString();
          timeWrap.setAttribute("data-end-time", iso);
          if (typeof window.__monetRefreshAuctionCountdownWrap === "function") {
            window.__monetRefreshAuctionCountdownWrap(timeWrap);
          }
        }
      }

      if (Object.prototype.hasOwnProperty.call(entry, "user_highest_ad_bid")) {
        var yourBidEl = document.getElementById("your_bid_" + id);
        if (yourBidEl) {
          if (entry.user_highest_ad_bid) {
            var cs = (yourBidEl.textContent || "").match(/(EUR|€|\$|£|¥)/i);
            var sign = cs ? cs[1] : "€";
            yourBidEl.textContent = entry.user_highest_ad_bid + " " + sign;
          } else {
            yourBidEl.textContent = "-----------";
          }
        }
      }

      if (entry.offer_bid != null && entry.offer_bid !== "") {
        var newMinVal = parseFloat(String(entry.offer_bid).replace(/\s/g, "").replace(",", ".")) || 0;
        var wf = document.getElementById("wishlist_offer_" + id);
        if (wf && document.activeElement !== wf) {
          var wCurrent = parseFloat((wf.value || "0").replace(/\s/g, "").replace(",", ".")) || 0;
          if (wCurrent <= newMinVal) wf.value = entry.offer_bid;
        }
        var bo = document.getElementById("bid_offer_amount_" + id);
        if (bo && document.activeElement !== bo) {
          var boCurrent = parseFloat((bo.value || "0").replace(/\s/g, "").replace(",", ".")) || 0;
          if (boCurrent <= newMinVal) bo.value = entry.offer_bid;
        }
      }
    });
    updateAllCountdowns();
  }

  function formatIsoEndTimeForAdminCard(isoValue) {
    if (!isoValue) return null;
    var d = new Date(isoValue);
    if (isNaN(d.getTime())) return null;
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0");
    var yyyy = String(d.getFullYear());
    var hh = String(d.getHours()).padStart(2, "0");
    var min = String(d.getMinutes()).padStart(2, "0");
    return dd + "." + mm + "." + yyyy + " " + hh + ":" + min;
  }

  function updateAllCountdowns() {
    // Re-query elements on each update to include dynamically loaded content
    const auctions = document.querySelectorAll('.auction_remaining_time');
    auctions.forEach(auction => updateCountdown(auction));
    forceSyncAdminAuctionEndControls();
  }

  function forceSyncAdminAuctionEndControls() {
    if (!document.getElementById('active-auction')) return;

    var cards = document.querySelectorAll('.items-type-1[data-auction-id]');
    cards.forEach(function(card) {
      var timeWrap = card.querySelector('.auction_remaining_time');
      if (!timeWrap) return;

      var cardAuctionId = card.getAttribute("data-auction-id");
      var endTimeAttr = timeWrap.getAttribute('data-end-time');
      var endedByTime = false;
      if (endTimeAttr) {
        var endTime = new Date(endTimeAttr);
        endedByTime = !isNaN(endTime.getTime()) && (endTime - new Date() <= 0);
      }

      var endedByText = false;
      var countdownEl = card.querySelector('.countdown');
      if (countdownEl) {
        var text = (countdownEl.textContent || '').toLowerCase();
        endedByText = (text.indexOf("time's up") >= 0 || text.indexOf("aika on ohi") >= 0);
      }

      if (!(endedByTime || endedByText)) return;

      var acceptLink =
        card.querySelector('.accept-reject-highest-bid-link') ||
        card.querySelector('a[data-enable-on-end="true"]') ||
        card.querySelector('a[href*="accept_reject_highest_bid"]') ||
        (cardAuctionId ? document.querySelector('a[href*="/admin/offers/' + cardAuctionId + '/accept_reject_highest_bid"]') : null);
      if (acceptLink) {
        acceptLink.classList.remove('disableattchmentbutton');
        acceptLink.classList.remove('auction-ended-not-reached');
      } else {
      }
    });
  }

  // Clear any existing interval to avoid duplicates
  if (window.countdownInterval) {
    clearInterval(window.countdownInterval);
  }

  // Update the countdown every second
  window.countdownInterval = setInterval(updateAllCountdowns, 1000);

  // Initialize countdown display
  updateAllCountdowns();

  // Real-time highest-bid updates (websocket) for admin manage-active-auctions.
  // Interval-based discovery ensures dynamically appended auctions are subscribed too.
  (function setupAdminAuctionRealtimeSubscriptions() {
    if (!document.getElementById('active-auction')) return;

    if (!window._adminAuctionRealtimeSubscribedIds) {
      window._adminAuctionRealtimeSubscribedIds = new Set();
    }

    if (window._adminAuctionRealtimeSubInterval) {
      // Already running (e.g. if this script is executed multiple times).
      return;
    }

    var subscribeLoopIntervalMs = 8000;

    function subscribeMissing() {
      var cards = document.querySelectorAll('.items-type-1[data-auction-id]');
      cards.forEach(function(card) {
        var auctionId = card.getAttribute('data-auction-id');
        if (!auctionId) return;
        if (window._adminAuctionRealtimeSubscribedIds.has(auctionId)) return;
        window._adminAuctionRealtimeSubscribedIds.add(auctionId);
        try {
          subscribeToAuction(auctionId, function(newEndTime) {
            if (!newEndTime) return;
            var cardsForAuction = document.querySelectorAll('.items-type-1[data-auction-id="' + auctionId + '"]');
            cardsForAuction.forEach(function(cardEl) {
              var timeWrap = cardEl.querySelector('.auction_remaining_time');
              if (!timeWrap) return;
              timeWrap.setAttribute('data-end-time', newEndTime);
              updateCountdown(timeWrap);

              var closeDateEl = cardEl.querySelector('#auction_close_date_' + auctionId);
              var formatted = formatIsoEndTimeForAdminCard(newEndTime);
              if (closeDateEl && formatted) {
                closeDateEl.textContent = formatted;
              }
            });
          });
        } catch (e) {
          console.warn('[AdminAuctionRealtime] subscribe failed for', auctionId, e);
          window._adminAuctionRealtimeSubscribedIds.delete(auctionId);
        }
      });
    }

    subscribeMissing();
    window._adminAuctionRealtimeSubInterval = setInterval(subscribeMissing, subscribeLoopIntervalMs);
  })();

  // Fallback reconciliation for manage_active_auctions:
  // keeps highest bid / close date accurate even if a websocket event is missed.
  (function setupAdminAuctionRealtimeFallbackRefresh() {
    if (!document.getElementById('active-auction')) return;
    if (window._adminAuctionFallbackSetupDone) return;
    window._adminAuctionFallbackSetupDone = true;

    function refreshAdminAuctionCardsFromServer() {
      var cards = document.querySelectorAll('#active-auction .items-type-1[data-auction-id]');
      if (!cards.length) return;
      var ids = [];
      cards.forEach(function(card) {
        var id = card.getAttribute('data-auction-id');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      if (!ids.length) return;

      fetch('/listing_prices?ids=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(payload) {
          if (!payload || typeof payload !== 'object') return;
          applyListingPricesPayloadToBidCards(payload);
        })
        .catch(function() {});
    }

    // Poll lightly; websocket remains the primary path.
    window._adminAuctionFallbackPollTimer = setInterval(function() {
      if (document.visibilityState !== 'visible') return;
      refreshAdminAuctionCardsFromServer();
    }, 15000);

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') refreshAdminAuctionCardsFromServer();
    });

    window.addEventListener('online', function() {
      refreshAdminAuctionCardsFromServer();
    });

    // Initial reconciliation
    setTimeout(refreshAdminAuctionCardsFromServer, 1000);
  })();

  // Wishlist + active bids: same data as manage-active-auctions but no #active-auction — poll listing_prices
  // so cards stay in sync when ActionCable is missed or another tab placed the bid.
  (function setupWishlistAndActiveBidsListingPoll() {
    if (window._bidAdminPanelsPollTimer) {
      clearInterval(window._bidAdminPanelsPollTimer);
      window._bidAdminPanelsPollTimer = null;
    }
    if (!isBidRealtimePagePath()) return;

    function collectBidPanelAuctionIds() {
      var seen = {};
      var roots = document.querySelectorAll("#fetch_own_wishlist, #fetch_active_bids");
      for (var r = 0; r < roots.length; r++) {
        var cards = roots[r].querySelectorAll(".items-type-1[data-auction-id]");
        for (var i = 0; i < cards.length; i++) {
          var aid = cards[i].getAttribute("data-auction-id");
          if (aid) seen[aid] = true;
        }
      }
      return Object.keys(seen);
    }

    function refreshBidAdminPanelsFromListingPrices() {
      if (!isBidRealtimePagePath()) return;
      if (document.visibilityState !== "visible") return;
      var ids = collectBidPanelAuctionIds();
      if (!ids.length) return;
      fetch("/listing_prices?ids=" + encodeURIComponent(ids.join(",")), { credentials: "same-origin" })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (payload) {
          if (!payload) return;
          applyListingPricesPayloadToBidCards(payload);
        })
        .catch(function () {});
    }

    window._bidAdminPanelsPollTimer = setInterval(refreshBidAdminPanelsFromListingPrices, 8000);

    if (!window._bidAdminPanelsListenersBound) {
      window._bidAdminPanelsListenersBound = true;
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible" && isBidRealtimePagePath()) {
          refreshBidAdminPanelsFromListingPrices();
        }
      });
      window.addEventListener("online", function () {
        if (isBidRealtimePagePath()) refreshBidAdminPanelsFromListingPrices();
      });
    }

    setTimeout(refreshBidAdminPanelsFromListingPrices, 1200);
  })();
}

document.addEventListener("DOMContentLoaded", initCountdownsAndAdminAuctionRealtime);
if (typeof Turbolinks !== "undefined" && Turbolinks.Events) {
  document.addEventListener("turbolinks:load", function() {
    // Allow re-init after Turbolinks navigation within the session.
    window._monetCountdownInitDone = false;
    initCountdownsAndAdminAuctionRealtime();
  });
}
if (typeof $ !== "undefined") {
  $(document).ready(initCountdownsAndAdminAuctionRealtime);
}

$(document).ready(function(){

  var url = window.location.href;
  url = url.split("/");
  if (url[6] == "edit?editable=false&step=3"){
    $("#editAuctionModal3").modal("show");
  }

  if (url[6] == "edit?editable=false&step=4"){
    $("#editAuctionModal4").modal("show");
  }

  if (url[5] == "manage_active_auctions?published=true"){
    $("#publishedActiveAuctionModal").modal("show");
  }

  if (url[5] == "manage_active_notices?published=true"){
    $("#publishedActiveNoticeModal").modal("show");
  }

  if (url[5] == "manage_active_ads?published=true"){
    $("#publishedActiveAdModal").modal("show");
  }

  // step 1
  $(document).on('click', '.selected_seller',  function() {
    if ($(this).is(':checked')){
      $(".selected_seller").prop('checked', false);
      $(this).prop('checked', true);
    }else{
      $(".selected_seller").prop('checked', true);
    }
  });

  $(document).on('change', '.upload_ad_attachment',  function() {
    var idArr = this.id.split("_");
    var id = idArr[idArr.length - 2];
    var ad_id = $("#ad_id").val();
    var form = $(this).closest('#ad-form-1');
    var authenticity_token = $(form).find('#authenticity_token').val();

    var attachment_name = $("#ad_attachment_attachment_" + id + '_name').val();
    var attachment_date = $("#ad_attachment_attachment_" + id + '_date').val();
    var images = $("#ad_attachment_attachment_" + id + '_attachment')[0].files

    var formData = new FormData();

    var obj = {};
    obj["id"] = ad_id;
    obj = JSON.stringify(obj);

    formData.append('attachment_name',attachment_name);
    formData.append('attachment_date',attachment_date);
    formData.append('attachment',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('user',obj);

    $.ajax({
      type:'PUT',
      url:'/admin/auctions/' + ad_id + '/upload_attachment',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  // step 2
  $(document).on('change', '#auction_images',  function() {
    var ad_id = $("#ad_id").val();
    var form = $(this).closest('#ad-form');
    var images = $(form).find('#auction_images')[0].files

    // Show notification immediately when file is selected
    var notificationEl = $('#image_upload_notification');
    if (notificationEl.length) {
      // Get translation from hidden field or use default
      var notificationText = $('#image_upload_processing_text').val() || 'Just a moment. Image has been uploaded and being compressed.';
      notificationEl.html('<div class="alert alert-success alert-dismissible" role="alert">' + notificationText + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
      notificationEl.show();
    }

    var formData = new FormData();
    // formData.append('attachment',images[0]);

    // Read selected files
    var totalfiles = document.getElementById('auction_images').files.length;
    for (var index = 0; index < totalfiles; index++) {
      formData.append("files[]", document.getElementById('auction_images').files[index]);
    }

    $.ajax({
      url: '/admin/auctions/' + ad_id + '/upload_auction_image',
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      success: function() {
        // Hide notification when upload completes (images will be rendered by response)
        setTimeout(function() {
          $('#image_upload_notification').fadeOut(500, function() {
            $(this).html('').hide();
          });
        }, 1000);
      },
      error: function() {
        // Hide notification on error too
        $('#image_upload_notification').fadeOut(500, function() {
          $(this).html('').hide();
        });
      }
    });
  });

  $(document).on("click", ".active_principal_private", function(){
    $('.active_principal_private').addClass('btn-primary');
    $('.active_principal_company').removeClass('btn-primary');
    $("#auction_principal_customer_type").val("PRIVATE");
    $( "#principal_company_info" ).addClass( "hide" );
    $( "#principal_private_info" ).removeClass( "hide" )
  });

  $(document).on("click", ".active_principal_company", function(){
    $('.active_principal_company').addClass('btn-primary');
    $('.active_principal_private').removeClass('btn-primary');
    $("#auction_principal_customer_type").val("COMPANY");
    $( "#principal_private_info" ).addClass( "hide" );
    $( "#principal_company_info" ).removeClass( "hide" );
  });

  $(document).on('click', '#groupAd',  function() {
    $(".group_ad_type").removeClass("disableattchmentbutton");
  });

  $(document).on('click', '#singleAd',  function() {
    $(".group_ad_type").addClass("disableattchmentbutton");
  });

  $(document).on('change', '#auction_group_ad_template_id',  function() {
    var group_ad_template_id = $(this).val();
    var form = $(this).closest('#ad-form-1');
    var auction_ad_type = $(form).find('#groupAd').val();
    var ad_id = $("#group_ad_id").val();
    var obj = {};
    obj["ad_type"] = auction_ad_type;
    obj["group_ad_template_id"] = group_ad_template_id;

    $.ajax({
      url: '/admin/auctions/' + ad_id,
      type: 'PUT',
      data: {auction : obj, step: 1}
    });
  });

  $(document).on('shown.bs.modal', '#manageAdTemplatesModal', function() {
    var currentTemplateId = $('#auction_group_ad_template_id').val();
    $('#manageAdTemplatesModal .manage-ad-template-checkbox').prop('checked', false);
    if (currentTemplateId) {
      $('#manageAdTemplatesModal .manage-ad-template-checkbox[value="' + currentTemplateId + '"]').prop('checked', true);
    }
  });

  $(document).on('submit', '#remove_group_ad_templates_form', function() {
    var form = $('#ad-form-1');
    var text = form.find('input[name="auction[text]"]').val() || '';
    $('#remove_templates_auction_text').val(text);
    var body = '';
    var bodyHidden = form.find('input[type="hidden"][name="auction[body]"]');
    if (bodyHidden.length) {
      body = bodyHidden.val() || '';
    }
    var trixEditor = form.find('trix-editor')[0];
    if (trixEditor && trixEditor.editor) {
      try {
        body = trixEditor.editor.getDocument().toString() || body;
      } catch (e) {}
    }
    $('#remove_templates_auction_body').val(body);
  });

  $(document).on('click', '#auction_confirm_display_times_get',  function() {
    $("#display_time_info").removeClass("hide");
  });

  $(document).on('click', '#auction_confirm_display_times_separate, #auction_confirm_display_times_view',  function() {
    $("#display_time_info").addClass("hide");
  });

  $(document).on('click', '#auction_has_different_address',  function() {
    if ($(this).is(':checked')){
      $("#different_address_info").removeClass("hide");
      $("#auction_pickup_address").val("");
      $("#auction_pickup_post_number").val("");
      $("#auction_pickup_city").val("");
    } else{
      $("#different_address_info").addClass("hide");
      $("#auction_pickup_address").val($("#current_user_pickup_address_infoo").val());
      $("#auction_pickup_post_number").val($("#current_user_pickup_post_number_info").val());
      $("#auction_pickup_city").val($("#current_user_pickup_city_info").val());
    }
  });

  $(document).on('click', '.clear_pickup_address',  function() {
    $("#auction_pickup_address").val("");
    $("#auction_pickup_post_number").val("");
    $("#auction_pickup_city").val("");
  });

  $(document).on('click', '#auction_has_separate_client',  function() {
    if ($(this).is(':checked')){
      $("#separate_client_info").removeClass("hide");
    }else{
      $("#separate_client_info").addClass("hide");
    }
  });

  $(document).on('click', '.selected_branch_office',  function() {
    if ($(this).is(':checked')){
      $(".selected_branch_office").prop('checked', false);
      $(this).prop('checked', true);
    }else{
      $(".selected_branch_office").prop('checked', true);
    }
  });

  $(document).on('click', '.clear_auction_start_date',  function() {
    $("#auction_auction_date").val("");
    $("#auction_start_time_start_hours").val("");
    $("#auction_start_time_start_minutes").val("");
    setTimeout(function() {
      if ($("#auction_category").val() === 'auction_notice' && typeof window.validateAuctionNoticeSchedule === 'function') {
        window.validateAuctionNoticeSchedule();
      }
      var form = $("#auction-form");
      if (form.length && typeof window.validateAndToggleButtons === 'function') {
        window.validateAndToggleButtons(form);
      }
    }, 0);
  });

  $(document).on('click', '.clear_publication_date',  function() {
    $("#auction_publication_date").val("");
    $("#post_time_end_hours").val("");
    $("#post_time_end_minutes").val("");
    setTimeout(function() {
      if ($("#auction_category").val() === 'auction_notice' && typeof window.validateAuctionNoticeSchedule === 'function') {
        window.validateAuctionNoticeSchedule();
      }
      var form = $("#auction-form");
      if (form.length && typeof window.validateAndToggleButtons === 'function') {
        window.validateAndToggleButtons(form);
      }
    }, 0);
  });

  // step 3 - use 'change' so toggling works when user clicks the label as well as the radio
  function updateStep3VatLabels() {
    if ($("#auction_value_added_tax_no").is(':checked')) {
      $("#price_with_vat").addClass("hide");
      $(".confirmed_vat_label").removeClass("hide");
      $(".confirm_vat_label").addClass("hide");
      $(".set_starting_price_label").addClass("hide");
      $(".starting_price_vat_0_label").removeClass("hide");
      $("#auction_vat_type").val("0,0");
      $("#auction_vat_type").attr('disabled', true);
    } else {
      $("#price_with_vat").removeClass("hide");
      $(".confirmed_vat_label").addClass("hide");
      $(".confirm_vat_label").removeClass("hide");
      $(".set_starting_price_label").removeClass("hide");
      $(".starting_price_vat_0_label").addClass("hide");
      $("#auction_vat_type").attr('disabled', false);
      $("#auction_vat_type").val($("#auction_vat_type_info").val());
    }
  }

  $(document).on('change', '#auction_value_added_tax_no, #auction_value_added_tax_yes', updateStep3VatLabels);

  $(document).on('keyup, change', '#auction_starting_price_with_vat, #auction_vat_type',  function() {
    var price_without_vat = $("#auction_starting_price_with_vat").val();
    var auction_vat_type = $("#auction_vat_type").val();

    if (auction_vat_type == "0,0"){
      var price_with_vat = checkNumericValue(price_without_vat)
    }else{
      var price_with_vat = checkNumericValue(price_without_vat) / (1 + (checkNumericValue(auction_vat_type) / 100))
    }
    $("#auction_starting_price_without_vat").val(checkNumericValue(price_with_vat));
    $("#starting_price_withh_vat").val(checkNumericValue(price_with_vat));
    $(".starting_price_with_vat").val(checkNumericValue(price_with_vat));
    var vat_price = checkNumericValue(price_with_vat) - checkNumericValue(price_without_vat)
    $("#vat_price_in_eur").val(checkNumericValue(vat_price));
    $(".sendInvoiceButton").removeClass("disableattchmentbutton");
  });

  $(document).on('keyup', '#auction_maximum_bid',  function() {
    var minimum_ad = $("#auction_minimum_bid").val();
    var maximum_ad = $(this).val();
    setTimeout(function () {
      if(checkNumericValue(minimum_ad) > checkNumericValue(maximum_ad)){
        $("#auction_minimum_maximum_increase_notice").html(window.jsAlerts.wrapWarning(window.jsAlerts.t("auction_max_increase_must_exceed_min")))
        $(".checkMandatory").addClass("disableattchmentbutton");
      } else {
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_minimum_maximum_increase_notice").html("");
      }
    }, 500);
  });

  $(document).on('keyup', '#auction_minimum_bid',  function() {
    var minimum_ad = $(this).val();
    setTimeout(function () {
      if(minimum_ad < 5){
        $("#auction_minimum_maximum_increase_notice").html(window.jsAlerts.wrapWarning(window.jsAlerts.t("auction_minimum_increase_at_least_five")))
        $(".checkMandatory").addClass("disableattchmentbutton");
      } else {
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_minimum_maximum_increase_notice").html("");
      }
    }, 500);
  });

  $(document).on('click', '#immediate_sale_ad',  function() {
    if ($(this).is(':checked')){
      $("#immediate_purchase_date_info").removeClass("hide");
      $("#scheduled_purchase_date_info").addClass("hide");
      $("#auction_auction_date").removeClass("mandatory_field");
      $(".clear_auction_start_date").click();

      // Clear any date validation errors when switching to immediate
      $("#auction_publication_date_notice").html("");
      $(".checkMandatory").removeClass("disableattchmentbutton");

      // Re-validate form after changing mandatory fields (universal)
      var form = $(this).closest('form');
      setTimeout(function() {
        if (typeof window.validateAndToggleButtons === 'function') {
          window.validateAndToggleButtons(form);
        }
      }, 100);
    }else{
      $("#immediate_purchase_date_info").addClass("hide");
      $("#scheduled_purchase_date_info").removeClass("hide");
      $("#auction_auction_date").addClass("mandatory_field");
      // Re-validate form after changing mandatory fields (universal)
      var form = $(this).closest('form');
      setTimeout(function() {
        if (typeof window.validateAndToggleButtons === 'function') {
          window.validateAndToggleButtons(form);
        }
      }, 100);
    }
  });

  $(document).on('click', '#scheduled_sale_ad',  function() {
    if ($(this).is(':checked')){
      $("#scheduled_purchase_date_info").removeClass("hide");
      $("#immediate_purchase_date_info").addClass("hide");
      $("#auction_auction_date").addClass("mandatory_field");
      // Re-validate form after changing mandatory fields
      var form = $(this).closest('form');
      setTimeout(function() {
        if (typeof window.validateAndToggleButtons === 'function') {
          window.validateAndToggleButtons(form);
        }
      }, 100);
    }else{
      $("#scheduled_purchase_date_info").addClass("hide");
      $("#auction_auction_date").removeClass("mandatory_field");
      $("#immediate_purchase_date_info").removeClass("hide");
      $(".clear_auction_start_date").click();
      // Re-validate form after changing mandatory fields
      var form = $(this).closest('form');
      setTimeout(function() {
        if (typeof window.validateAndToggleButtons === 'function') {
          window.validateAndToggleButtons(form);
        }
      }, 100);
    }
  });

  $(document).on('click', '#not_specified',  function() {
    if ($(this).is(':checked')){
      $("#fixed_price_setting_info").addClass("hide");
      $("#auction_starting_price_without_vat").removeClass("mandatory_field");
      $("#auction_vat_type").removeClass("mandatory_field");
      $("#auction_starting_price_with_vat").removeClass("mandatory_field");
      $("#auction_starting_price_without_vat").val("");
    }else{
      $("#fixed_price_setting_info").removeClass("hide");
      $("#auction_starting_price_without_vat").addClass("mandatory_field");
      $("#auction_vat_type").addClass("mandatory_field");
      $("#auction_starting_price_with_vat").addClass("mandatory_field");
    }
  });

  $(document).on('click', '#fixed_price_settings',  function() {
    if ($(this).is(':checked')){
      $("#fixed_price_setting_info").removeClass("hide");
      $("#auction_starting_price_without_vat").addClass("mandatory_field");
      $("#auction_vat_type").addClass("mandatory_field");
      $("#auction_starting_price_with_vat").addClass("mandatory_field");
    }else{
      $("#fixed_price_setting_info").addClass("hide");
      $("#auction_starting_price_without_vat").removeClass("mandatory_field");
      $("#auction_vat_type").removeClass("mandatory_field");
      $("#auction_starting_price_with_vat").removeClass("mandatory_field");
    }
  });

  $(document).on('click', '#separate_with_seller',  function() {
    if ($(this).is(':checked')){
      $("#more_pick_up_info").addClass("hide");
      $(".auction_pickup_info").val("");
    }else{
      $("#more_pick_up_info").removeClass("hide");
    }
  });

  $(document).on('click', '#more_pick_up_details',  function() {
    if ($(this).is(':checked')){
      $("#more_pick_up_info").removeClass("hide");
    }else{
      $("#more_pick_up_info").addClass("hide");
      $(".auction_pickup_info").val("");
    }
  });

  // step 4
  $(document).on('click', '#auction_save_as_group_ad',  function() {
    if ($(this).is(':checked')){
      $("#group_ad_template_content").removeClass("hide");
      $("#auction_group_ad_template_name").addClass("mandatory_field");
    }else{
      $("#group_ad_template_content").addClass("hide");
      $("#auction_group_ad_template_name").removeClass("mandatory_field");
    }
  });

  $(document).on('click', '.form-check-input',  function() {
    if ($(this).is(':checked')){
      $(this).closest("li").addClass("checked");
    }else{
      $(this).closest("li").removeClass("checked");
    }
  });

  $(document).on('click', '.bid_offer_button',  function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if ($(this).hasClass('disableattchmentbutton') || $(this).prop('disabled')) {
      return false;
    }

    var id = getId(this.id); // This is offer.id for the route
    // Get auction_id from button's data attribute or container's data attribute
    var auction_id = $(this).attr('data-auction-id') || $(this).closest('.items-type-1').attr('data-auction-id') || $("#auction_id_"+ id).val();
    // Get offer_amount using auction.id (for compatibility with live updates)
    var offer_amount = $("#bid_offer_amount_"+ auction_id).val();
    // Get user_id using auction.id (for compatibility with live updates)
    var user_id = $("#user_id_"+ auction_id).val() || $("#user_id_"+ id).val();

    if (!offer_amount || !auction_id || !user_id) {
      alert((window.jsAlerts && window.jsAlerts.t("error_missing_required_refresh")) || "Pakollisia tietoja puuttuu. Päivitä sivu ja yritä uudelleen.");
      return false;
    }

    var bidAmount = checkNumericValue(offer_amount);
    var highestAdBid = checkNumericValue($("#highest_ad_bid_"+ auction_id).val());
    var maximumIncrease = checkNumericValue($("#maximum_price_"+ auction_id).val());
    var $notice = $(this).closest('.items-type-1').find('[id^="auction_offer_notice_"]');

    if (maximumIncrease > 0 && (bidAmount - highestAdBid) > maximumIncrease) {
      $notice.html(window.jsAlerts.wrapWarning(window.jsAlerts.t("bid_exceeds_maximum_increase", { maximum: maximumIncrease, currency: "EUR" })));
      $(this).addClass("disableattchmentbutton");
      return false;
    }

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/'+ id +'/save_an_offer',
        type: 'PUT',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          offer: {
            offer_amount: offer_amount,
            auction_id: auction_id,
            user_id: user_id
          }
        },
        success: function(data) {
          window.location.reload();
        },
        error: function(xhr) {
          $("#loader-image").hide();
          window.location.reload();
        }
      });
    }, 500);

    return false;
  });

  $(document).on('keyup', '.wishlist_offer',  function() {
    var auctionId = getId(this.id);
    var bidAmount = checkNumericValue($("#wishlist_offer_" + auctionId).val());
    var highestAdBid = checkNumericValue($("#highest_ad_bid_" + auctionId).val());
    var minimumIncrease = checkNumericValue($("#minimum_price_" + auctionId).val());
    var maximumIncrease = checkNumericValue($("#maximum_price_" + auctionId).val());
    var $button = $(this).closest('.row').find('.wishlist_offer_button');
    var $notice = $(this).closest('.col-12.col-lg-7').find('[id^="auction_offer_notice_"]');

    setTimeout(function () {
      var minimumRequired = highestAdBid + minimumIncrease;
      if(minimumIncrease > 0 && bidAmount < minimumRequired){
        $notice.html(window.jsAlerts.wrapWarning(window.jsAlerts.t("bid_below_minimum_increase")));
        $button.addClass("disableattchmentbutton");
      } else if(maximumIncrease > 0 && (bidAmount - highestAdBid) > maximumIncrease){
        $notice.html(window.jsAlerts.wrapWarning(window.jsAlerts.t("bid_exceeds_maximum_increase", { maximum: maximumIncrease, currency: "EUR" })));
        $button.addClass("disableattchmentbutton");
      } else {
        $notice.html("");
        $button.removeClass("disableattchmentbutton");
      }
    }, 500);
  });

  $(document).on('click', '.wishlist_offer_button',  function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if ($(this).hasClass('disableattchmentbutton') || $(this).prop('disabled')) {
      return false;
    }

    var id = getId(this.id);
    var offer_amount = $("#wishlist_offer_"+ id).val();
    var wish_id = $("#wish_id_"+ id).val();
    var auction_id = $("#auction_id_"+ id).val();
    var user_id = $("#user_id_"+ id).val();

    if (!offer_amount || !auction_id || !user_id) {
      alert((window.jsAlerts && window.jsAlerts.t("error_missing_required_refresh")) || "Pakollisia tietoja puuttuu. Päivitä sivu ja yritä uudelleen.");
      return false;
    }

    var bidAmount = checkNumericValue(offer_amount);
    var highestAdBid = checkNumericValue($("#highest_ad_bid_"+ auction_id).val());
    var maximumIncrease = checkNumericValue($("#maximum_price_"+ auction_id).val());
    var $notice = $(this).closest('.items-type-1').find('[id^="auction_offer_notice_"]');

    if (maximumIncrease > 0 && (bidAmount - highestAdBid) > maximumIncrease) {
      $notice.html(window.jsAlerts.wrapWarning(window.jsAlerts.t("bid_exceeds_maximum_increase", { maximum: maximumIncrease, currency: "EUR" })));
      $(this).addClass("disableattchmentbutton");
      return false;
    }

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/'+ id +'/save_wishlist_offer',
        type: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          offer: {
            offer_amount: offer_amount,
            auction_id: auction_id,
            user_id: user_id
          },
          wish_id: wish_id
        },
        success: function(data) {
          window.location.reload();
        },
        error: function(xhr) {
          $("#loader-image").hide();
          window.location.reload();
        }
      });
    }, 500);

    return false;
  });

  $(document).on('click', '.submit_publication_date',  function() {
    var id = $("#auction_id").val();

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/auctions/'+ id +'/save_publication_date',
        type: 'PUT',
        data: {auction_id : id, publication_date : $("#auction_publication_date").val(), end_hour : $("#post_time_end_hours").val(), end_min : $("#post_time_end_minutes").val()}
      });
    }, 500);
  });

  $(document).on('click', '#active_auction_tab',  function() {    
    $(".active_auction_header").removeClass("hide");
    $(".upcoming_auction_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_auction_tab',  function() {    
    $(".upcoming_auction_header").removeClass("hide");
    $(".active_auction_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#failed_auction_tab',  function() {    
    $(".failed_auction_header").removeClass("hide");
    $(".successful_auction_header").addClass("hide");
  });

  $(document).on('click', '#successful_auction_tab',  function() {    
    $(".successful_auction_header").removeClass("hide");
    $(".failed_auction_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#active_notice_tab',  function() {    
    $(".active_notice_header").removeClass("hide");
    $(".upcoming_notice_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_notice_tab',  function() {    
    $(".upcoming_notice_header").removeClass("hide");
    $(".active_notice_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#failed_notice_tab',  function() {    
    $(".cancelled_notice_header").removeClass("hide");
    $(".successful_notice_header").addClass("hide");
  });

  $(document).on('click', '#successful_notice_tab',  function() {    
    $(".successful_notice_header").removeClass("hide");
    $(".cancelled_notice_header").addClass("hide");
    secondPagination()
  });

  $(document).on('click', '#active_ad_tab',  function() {    
    $(".active_ad_header").removeClass("hide");
    $(".upcoming_ad_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_ad_tab',  function() {    
    $(".upcoming_ad_header").removeClass("hide");
    $(".active_ad_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#cancelled_ad_tab',  function() {    
    $(".cancelled_ad_header").removeClass("hide");
    $(".successful_ad_header").addClass("hide");
  });

  $(document).on('click', '#successful_ad_tab',  function() {    
    $(".successful_ad_header").removeClass("hide");
    $(".cancelled_ad_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '.accept_ad',  function() {
    var id = getId(this.id);
    $("#reject_ad_div_" + id).addClass("hide");
    $('#reject_ad_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#accept_ad_div_" + id).removeClass("hide");
    }else{
      $("#accept_ad_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.reject_ad',  function() {
    var id = getId(this.id);
    $("#accept_ad_div_" + id).addClass("hide");
    $('#accept_ad_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#reject_ad_div_" + id).removeClass("hide");
    }else{
      $("#reject_ad_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.accept_changes',  function() {
    var id = getId(this.id);
    $("#reject_changes_div_" + id).addClass("hide");
    $('#reject_changes_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#accept_changes_div_" + id).removeClass("hide");
    }else{
      $("#accept_changes_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.reject_changes',  function() {
    var id = getId(this.id);
    $("#accept_changes_div_" + id).addClass("hide");
    $('#accept_changes_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#reject_changes_div_" + id).removeClass("hide");
    }else{
      $("#reject_changes_div_" + id).addClass("hide");
    }
  });

  $(document).on('change', '#invoice_payment_receipt',  function() {
    var invoice_id = $("#invoice_id").val();
    var form = $(this).closest('#invoice_receipt_form');
    var images = $(form).find('#invoice_payment_receipt')[0].files

    var formData = new FormData();
    formData.append('attachment',images[0]);

    $.ajax({
      url: '/invoices/' + invoice_id + '/upload_payment_receipt',
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  $(document).on('keyup, change', '#seller_price_without_vat, #seller_vat_type',  function() {
    var price_without_vat = $("#seller_price_without_vat").val();
    var seller_vat_type = $("#seller_vat_type").val();

    if (seller_vat_type == "0,0"){
      var price_with_vat = checkNumericValue(price_without_vat)
    }else{
      var price_with_vat = checkNumericValue(price_without_vat) * (1 + (checkNumericValue(seller_vat_type) / 100))
    }
    $("#seller_price_with_vat").val(checkNumericValue(price_with_vat));
    var vat_price = checkNumericValue(price_with_vat) - checkNumericValue(price_without_vat)
    $("#seller_vat_price_in_eur").val(checkNumericValue(vat_price));
    $(".sendInvoiceButton").removeClass("disableattchmentbutton");
  });

});

function secondPagination() {
  if ($('.second_pagination').length) {
    $(document).scroll(function() {
      var url = $('.second_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.second_pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }
}

function checkNumericValue(number, decimal_points = 2) {
  if (number){
    return parseFloat(parseFloat(number.toString().replace(' ', '').replace(",", ".")).toFixed(decimal_points));
  }
  else{
    return 0;
  }
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

function isBidRealtimePagePath() {
  var path = window.location && window.location.pathname ? window.location.pathname : "";
  return path.includes('/admin/offers/check_own_wishlist') || path.includes('/admin/offers/open_active_bids');
}

function ensureBidPagesRealtimeSubscriptions() {
  if (!isBidRealtimePagePath()) return;
  subscribeToAllAuctionsOnPage();
}

function setupBidPagesRealtimeSubscriptions() {
  if (window._bidPagesRealtimeSetupDone) return;
  window._bidPagesRealtimeSetupDone = true;

  // Initial attach
  ensureBidPagesRealtimeSubscriptions();

  // Turbolinks/AJAX pages can replace cards after initial load.
  // Keep attaching subscriptions for newly rendered auction cards.
  window._bidPagesRealtimePollTimer = setInterval(function() {
    ensureBidPagesRealtimeSubscriptions();
  }, 5000);

  $(document).on('ajax:complete', function() {
    ensureBidPagesRealtimeSubscriptions();
  });
}

$(document).ready(function() {
  resetBidPageAuctionSubscriptions();
  setupBidPagesRealtimeSubscriptions();
});
if (typeof Turbolinks !== "undefined" && Turbolinks.Events) {
  document.addEventListener("turbolinks:load", function() {
    resetBidPageAuctionSubscriptions();
    setupBidPagesRealtimeSubscriptions();
    ensureBidPagesRealtimeSubscriptions();
  });
}

function round5(x)
{
    return Math.ceil(x / 5) * 5;
}